// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1f90d91","455":"6e63e858","977":"e3a5abd4"}[chunkId] + ".chunk.js";
};